import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useCreateThana } from "src/basic-rest/useFetchAddressData";
import { useState } from "react";
import { IThanaList } from "src/basic-rest/types";
import Toaster from "src/Toaster/Toaster";

export default function CreateThana({ district_id, setThana }) {
  const { createThanaData, loading: submitLoading } = useCreateThana();
  const Toast = Toaster();
  const [value, setValue] = useState<string>("");

  const submit = async (e) => {
    e.preventDefault();

    if (!value) {
      Toast.fire({
        icon: "error",
        title: "Provide thana name",
      });
      return;
    }
    const data = await createThanaData({ district_id, thana_name: value });

    if (data.success) {
      setValue("");
      setThana((thana: IThanaList[]) => [
        ...thana,
        {
          thana_id: data.data.thana_id,
          thana_name: value,
          district_id: thana.length ? thana[0].district_id : district_id,
          district_name: thana.length ? thana[0].district_name : "",
          division_id: thana.length ? thana[0].division_id : 1,
          division_name: thana.length ? thana[0].division_name : "",
        },
      ]);
    }
  };

  return (
    <Stack
      component="form"
      sx={{
        width: "35ch",
        p: 2,
      }}
      spacing={2}
      noValidate
      autoComplete="off"
      onSubmit={submit}
    >
      <TextField
        id="test"
        label="Thana Name"
        defaultValue="Small"
        size="small"
        required
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />

      <Button disabled={submitLoading} type="submit" variant="contained">
        {submitLoading ? "Please wait" : "Create thana"}
      </Button>
    </Stack>
  );
}
